var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBaggage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "var(--primary-color)",
    strokeWidth: 10
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 40,
    width: 100,
    height: 120,
    rx: 15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 85,
    y1: 40,
    x2: 85,
    y2: 160
  }), /*#__PURE__*/React.createElement("line", {
    x1: 115,
    y1: 40,
    x2: 115,
    y2: 160
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 10,
    width: 50,
    height: 30,
    rx: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 170,
    r: 7,
    fill: "red"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 135,
    cy: 170,
    r: 7,
    fill: "red"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaggage);
export default __webpack_public_path__ + "static/media/baggage.b61914931640f82fa53aab5bea9a33d4.svg";
export { ForwardRef as ReactComponent };